<template>
  <div class="max-w-md mx-auto my-5 p-2">
    <button
      class="my-3 px-3 py-1 border border-gray-300 rounded print:hidden"
      @click="printThePage"
    >Print</button>
    <p class="whitespace-pre-wrap text-xs leading-none">{{ printOut }}</p>
  </div>
</template>

<script>
import store from "@/store/index.js";

export default {
  name: "print",
  computed: {
    numberOfTransactions() {
      return this.$store.getters.numberOfTransactions;
    },
    income() {
      return this.$store.getters.income;
    },
    outcome() {
      return this.$store.getters.outcome;
    },
    total() {
      return this.income - this.outcome;
    },
    paginatedTransactions() {
      return this.$store.getters.paginatedTransactions;
    },
    incomeTransactions() {
      if (this.$store.getters.paginatedTransactions.length > 0) {
        return this.$store.getters.paginatedTransactions.filter(
          obj => obj.type === "income"
        ).length;
      } else {
        return 0;
      }
    },
    expenseTransactions() {
      if (this.$store.getters.paginatedTransactions.length > 0) {
        return this.$store.getters.paginatedTransactions.filter(
          obj => obj.type === "outcome"
        ).length;
      } else {
        return 0;
      }
    },
    printOut() {
      if (this.paginatedTransactions.length > 0) {
        let start = new Date(this.startDate).toLocaleDateString();
        let end = new Date(this.endDate).toLocaleDateString();
        let index = 1;

        let message = `Period: ${start} - ${end}\n\n`;

        message += `Number of transactions: ${this.numberOfTransactions} (In: ${this.incomeTransactions}, Exp: ${this.expenseTransactions})\n`;
        message += `Income: £${this.income}\n`;
        message += `Expense: £${this.outcome}\n`;
        message += `Total: £${this.total}\n\n`;

        for (let obj of this.paginatedTransactions) {
          message += `${index}.\n`;
          message += `Date: ${new Date(obj.date).toLocaleDateString()}, `;
          message += `Amount: £${obj.amount}, `;
          message += `Type: ${obj.type === "income" ? "Income" : "Expense"}, `;
          message += `Note: ${obj.description ? obj.description : "N/A"}\n\n`;
          index++;
        }

        return message;
      }
    },
    startDate() {
      return this.$store.getters.startDate;
    },
    endDate() {
      return this.$store.getters.endDate;
    }
  },
  methods: {
    printThePage() {
      console.log("print");
      window.print();
    }
  },
  mounted() {},
  filters: {
    formatDate(isoDate) {
      if (!isoDate) {
        return "";
      }

      return new Date(isoDate).toLocaleDateString();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>